/** @jsxImportSource @emotion/react */
import { ReactNode } from "react";

import { css } from "@emotion/react";

import { ROUTES, TABLE_NAMES, useStyles } from "../../shared";
import PageHeader from "../PageHeader/PageHeader";

interface ILayoutNodetailsProps {
  route: ROUTES;
  tableName: TABLE_NAMES;
  children: ReactNode;
  infoIconTooltip?: string;
}

const LayoutNoDetails = ({
  route,
  tableName,
  children,
  infoIconTooltip,
}: ILayoutNodetailsProps) => {
  const { pageLayout } = useStyles();

  return (
    <div data-testid="layout-no-details" css={css(pageLayout)}>
      <PageHeader
        route={route}
        tableName={tableName}
        infoIconTooltip={infoIconTooltip}
      >
        {children}
      </PageHeader>
    </div>
  );
};

export default LayoutNoDetails;
